import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEligibilitySuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <circle cx={7} cy={7} r={7} fill="#DEEDEC" />
    <circle cx={7} cy={7} r={3} fill="#44BBB5" />
  </svg>
);
export default SvgEligibilitySuccess;
